import { render, staticRenderFns } from "./AddDoctorFormModal.vue?vue&type=template&id=26f26c24&"
import script from "./AddDoctorFormModal.vue?vue&type=script&lang=js&"
export * from "./AddDoctorFormModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDoctorFormModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports